import React from "react";
import { JokerTrackerProps } from "@/lib/types";
import { getWeekRange } from "@/lib/dateUtils";

interface ProgressCircleProps {
  value: number;
  maxValue: number;
  color: string;
  label: string;
  textColor?: string;
}

const ProgressCircle: React.FC<ProgressCircleProps> = ({
  value,
  maxValue,
  color,
  label,
  textColor = "inherit",
}) => {
  // Calculate the stroke-dashoffset based on the percentage
  const radius = 54;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / maxValue) * circumference;

  return (
    <div className="flex flex-col items-center">
      <div className="relative">
        <svg
          className="progress-circle"
          width="40"
          height="40"
          viewBox="0 0 120 120"
        >
          <circle
            cx="60"
            cy="60"
            r={radius}
            fill="none"
            stroke="#e6e6e6"
            strokeWidth="12"
          />
          <circle
            cx="60"
            cy="60"
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span
            className="font-mono text-sm font-semibold"
            style={{ color: textColor }}
          >
            {value}/{maxValue}
          </span>
        </div>
      </div>
      <span className="text-xs mt-1 font-medium">{label}</span>
    </div>
  );
};

const WeeklyStatusTracker: React.FC<JokerTrackerProps> = ({
  jokerDaysTaken,
  maxJokerDays,
}) => {
  return (
    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
      <div className="flex justify-between items-center">
        <div>
          <h3 className="font-heading text-sm font-semibold text-neutral">
            Week Progress
          </h3>
          <p className="text-xs text-gray-500">{getWeekRange()}</p>
        </div>
        <div className="flex justify-end">
          <ProgressCircle
            value={jokerDaysTaken}
            maxValue={maxJokerDays}
            color="#FFC107"
            label="Joker Days"
            textColor="#333333"
          />
        </div>
      </div>
    </div>
  );
};

export default WeeklyStatusTracker;
